import { Plus } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { useAuthModal } from "../lib/authModal";

export default function FabAnunciar() {
  const nav = useNavigate();
  const { requireAuth } = useAuthModal();

  const onClick = () => {
    requireAuth(() => nav("/novo-anuncio"));
  };

  return (
    <button
      onClick={onClick}
      className="fixed right-4 z-30 bg-[#FF6B35] text-white rounded-full pl-3 pr-5 py-3 flex items-center gap-2 shadow-lg hover:bg-[#E5552A] transition-all hover:scale-105"
      style={{
        bottom: "calc(88px + var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)))",
        boxShadow: "0 8px 24px rgba(255, 107, 53, 0.45)",
      }}
      data-testid="fab-anunciar"
      aria-label="Anunciar"
    >
      <Plus size={22} weight="bold" />
      <span className="font-bold text-sm">Anuncie agora</span>
    </button>
  );
}
